// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"JT","tooltipWrapper":"KT","tooltip":"LT","content":"MT"};